'use strict';

exports.__esModule = true;
exports.get = get;
exports.post = post;
exports.put = put;
exports.remove = remove;

var _client = require('../client');

var _client2 = _interopRequireDefault(_client);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _utils = require('../api-client/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var apiClient = {
  get: get,
  post: post,
  put: put,
  remove: remove
};

exports.default = apiClient;
function get(_ref) {
  var route = _ref.route,
      params = _ref.params,
      includeAuth = _ref.includeAuth;

  return _client2.default.get({ url: _config2.default.api.gatewayUrl + route, params: params, headers: (0, _utils.createHeaders)(includeAuth) });
}

function post(_ref2) {
  var route = _ref2.route,
      data = _ref2.data,
      includeAuth = _ref2.includeAuth,
      overrideHeaders = _ref2.overrideHeaders,
      formData = _ref2.formData;

  return _client2.default.post({
    url: _config2.default.api.gatewayUrl + route,
    data: data,
    formData: formData,
    headers: (0, _utils.createHeaders)(includeAuth, formData, overrideHeaders)
  });
}

function put(_ref3) {
  var route = _ref3.route,
      data = _ref3.data,
      includeAuth = _ref3.includeAuth;

  return _client2.default.put({ url: _config2.default.api.gatewayUrl + route, data: data, headers: (0, _utils.createHeaders)(includeAuth) });
}

function remove(_ref4) {
  var route = _ref4.route,
      params = _ref4.params,
      includeAuth = _ref4.includeAuth;

  return _client2.default.remove({ url: _config2.default.api.gatewayUrl + route, params: params, headers: (0, _utils.createHeaders)(includeAuth) });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/quiqupjs/lib/network/gateway/index.js
// module id = 184
// module chunks = 0